import Navigation from './Navigation';

export default Navigation;


// WEBPACK FOOTER //
// ./src/modules/navigation/index.js